// SPDX-License-Identifier: GPL-3.0-only

import * as JSONFILE_IDS from "./JSONFILE_IDS.js";

export const JSON_AR = [
  {
    id: JSONFILE_IDS.JSON_VERSIONINFO,
    file: "json/version-info.json",
  },
];
